
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ja",
  "fr",
  "it"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_pickerIntegration_46json_a1977f9f",
      load: () => import("#nuxt-i18n/a1977f9f" /* webpackChunkName: "locale_pickerIntegration_46json_a1977f9f" */),
      cache: true
    },
    {
      key: "locale_bundleInspector_46json_af9869f1",
      load: () => import("#nuxt-i18n/af9869f1" /* webpackChunkName: "locale_bundleInspector_46json_af9869f1" */),
      cache: true
    },
    {
      key: "locale_account_46json_8c8d176e",
      load: () => import("#nuxt-i18n/8c8d176e" /* webpackChunkName: "locale_account_46json_8c8d176e" */),
      cache: true
    },
    {
      key: "locale_signin_46json_ccc956b6",
      load: () => import("#nuxt-i18n/ccc956b6" /* webpackChunkName: "locale_signin_46json_ccc956b6" */),
      cache: true
    },
    {
      key: "locale_checkout_46json_6a9c6141",
      load: () => import("#nuxt-i18n/6a9c6141" /* webpackChunkName: "locale_checkout_46json_6a9c6141" */),
      cache: true
    },
    {
      key: "locale_navbar_46json_8129ca87",
      load: () => import("#nuxt-i18n/8129ca87" /* webpackChunkName: "locale_navbar_46json_8129ca87" */),
      cache: true
    },
    {
      key: "locale_welcome_46json_cea8eebe",
      load: () => import("#nuxt-i18n/cea8eebe" /* webpackChunkName: "locale_welcome_46json_cea8eebe" */),
      cache: true
    },
    {
      key: "locale_gallery_46json_69201ad0",
      load: () => import("#nuxt-i18n/69201ad0" /* webpackChunkName: "locale_gallery_46json_69201ad0" */),
      cache: true
    },
    {
      key: "locale_collections_46json_cb33cd90",
      load: () => import("#nuxt-i18n/cb33cd90" /* webpackChunkName: "locale_collections_46json_cb33cd90" */),
      cache: true
    },
    {
      key: "locale_distribution_46json_01cb5300",
      load: () => import("#nuxt-i18n/01cb5300" /* webpackChunkName: "locale_distribution_46json_01cb5300" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_pickerIntegration_46json_104b9572",
      load: () => import("#nuxt-i18n/104b9572" /* webpackChunkName: "locale_pickerIntegration_46json_104b9572" */),
      cache: true
    },
    {
      key: "locale_bundleInspector_46json_9251ac7d",
      load: () => import("#nuxt-i18n/9251ac7d" /* webpackChunkName: "locale_bundleInspector_46json_9251ac7d" */),
      cache: true
    },
    {
      key: "locale_account_46json_8faed444",
      load: () => import("#nuxt-i18n/8faed444" /* webpackChunkName: "locale_account_46json_8faed444" */),
      cache: true
    },
    {
      key: "locale_signin_46json_f2e25b4f",
      load: () => import("#nuxt-i18n/f2e25b4f" /* webpackChunkName: "locale_signin_46json_f2e25b4f" */),
      cache: true
    },
    {
      key: "locale_checkout_46json_cef7476d",
      load: () => import("#nuxt-i18n/cef7476d" /* webpackChunkName: "locale_checkout_46json_cef7476d" */),
      cache: true
    },
    {
      key: "locale_navbar_46json_a44954bc",
      load: () => import("#nuxt-i18n/a44954bc" /* webpackChunkName: "locale_navbar_46json_a44954bc" */),
      cache: true
    },
    {
      key: "locale_welcome_46json_32d7e87d",
      load: () => import("#nuxt-i18n/32d7e87d" /* webpackChunkName: "locale_welcome_46json_32d7e87d" */),
      cache: true
    },
    {
      key: "locale_gallery_46json_c0b8b713",
      load: () => import("#nuxt-i18n/c0b8b713" /* webpackChunkName: "locale_gallery_46json_c0b8b713" */),
      cache: true
    },
    {
      key: "locale_collections_46json_c243d415",
      load: () => import("#nuxt-i18n/c243d415" /* webpackChunkName: "locale_collections_46json_c243d415" */),
      cache: true
    },
    {
      key: "locale_distribution_46json_e964d7ff",
      load: () => import("#nuxt-i18n/e964d7ff" /* webpackChunkName: "locale_distribution_46json_e964d7ff" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_pickerIntegration_46json_6d51d024",
      load: () => import("#nuxt-i18n/6d51d024" /* webpackChunkName: "locale_pickerIntegration_46json_6d51d024" */),
      cache: true
    },
    {
      key: "locale_bundleInspector_46json_fa64658b",
      load: () => import("#nuxt-i18n/fa64658b" /* webpackChunkName: "locale_bundleInspector_46json_fa64658b" */),
      cache: true
    },
    {
      key: "locale_account_46json_6b5c11f4",
      load: () => import("#nuxt-i18n/6b5c11f4" /* webpackChunkName: "locale_account_46json_6b5c11f4" */),
      cache: true
    },
    {
      key: "locale_signin_46json_ade458fd",
      load: () => import("#nuxt-i18n/ade458fd" /* webpackChunkName: "locale_signin_46json_ade458fd" */),
      cache: true
    },
    {
      key: "locale_checkout_46json_6ce60197",
      load: () => import("#nuxt-i18n/6ce60197" /* webpackChunkName: "locale_checkout_46json_6ce60197" */),
      cache: true
    },
    {
      key: "locale_navbar_46json_7e958f36",
      load: () => import("#nuxt-i18n/7e958f36" /* webpackChunkName: "locale_navbar_46json_7e958f36" */),
      cache: true
    },
    {
      key: "locale_welcome_46json_e9d0b484",
      load: () => import("#nuxt-i18n/e9d0b484" /* webpackChunkName: "locale_welcome_46json_e9d0b484" */),
      cache: true
    },
    {
      key: "locale_gallery_46json_7b508a03",
      load: () => import("#nuxt-i18n/7b508a03" /* webpackChunkName: "locale_gallery_46json_7b508a03" */),
      cache: true
    },
    {
      key: "locale_collections_46json_c4b42622",
      load: () => import("#nuxt-i18n/c4b42622" /* webpackChunkName: "locale_collections_46json_c4b42622" */),
      cache: true
    },
    {
      key: "locale_distribution_46json_e6f13848",
      load: () => import("#nuxt-i18n/e6f13848" /* webpackChunkName: "locale_distribution_46json_e6f13848" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_pickerIntegration_46json_08e9f67b",
      load: () => import("#nuxt-i18n/08e9f67b" /* webpackChunkName: "locale_pickerIntegration_46json_08e9f67b" */),
      cache: true
    },
    {
      key: "locale_bundleInspector_46json_7e19457b",
      load: () => import("#nuxt-i18n/7e19457b" /* webpackChunkName: "locale_bundleInspector_46json_7e19457b" */),
      cache: true
    },
    {
      key: "locale_account_46json_0390c9dd",
      load: () => import("#nuxt-i18n/0390c9dd" /* webpackChunkName: "locale_account_46json_0390c9dd" */),
      cache: true
    },
    {
      key: "locale_signin_46json_7c1c0bab",
      load: () => import("#nuxt-i18n/7c1c0bab" /* webpackChunkName: "locale_signin_46json_7c1c0bab" */),
      cache: true
    },
    {
      key: "locale_checkout_46json_f19023da",
      load: () => import("#nuxt-i18n/f19023da" /* webpackChunkName: "locale_checkout_46json_f19023da" */),
      cache: true
    },
    {
      key: "locale_navbar_46json_89f18b78",
      load: () => import("#nuxt-i18n/89f18b78" /* webpackChunkName: "locale_navbar_46json_89f18b78" */),
      cache: true
    },
    {
      key: "locale_welcome_46json_0d07c49a",
      load: () => import("#nuxt-i18n/0d07c49a" /* webpackChunkName: "locale_welcome_46json_0d07c49a" */),
      cache: true
    },
    {
      key: "locale_gallery_46json_7a107dd7",
      load: () => import("#nuxt-i18n/7a107dd7" /* webpackChunkName: "locale_gallery_46json_7a107dd7" */),
      cache: true
    },
    {
      key: "locale_collections_46json_bcd7964f",
      load: () => import("#nuxt-i18n/bcd7964f" /* webpackChunkName: "locale_collections_46json_bcd7964f" */),
      cache: true
    },
    {
      key: "locale_distribution_46json_643fc2e7",
      load: () => import("#nuxt-i18n/643fc2e7" /* webpackChunkName: "locale_distribution_46json_643fc2e7" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: ".",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        {
          path: "/app/monocle-gallery/locales/en/pickerIntegration.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/bundleInspector.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/account.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/signin.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/checkout.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/navbar.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/welcome.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/gallery.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/collections.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/en/distribution.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      language: "ja-JP",
      name: "日本語",
      files: [
        {
          path: "/app/monocle-gallery/locales/ja/pickerIntegration.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/bundleInspector.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/account.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/signin.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/checkout.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/navbar.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/welcome.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/gallery.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/collections.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/ja/distribution.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      files: [
        {
          path: "/app/monocle-gallery/locales/fr/pickerIntegration.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/bundleInspector.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/account.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/signin.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/checkout.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/navbar.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/welcome.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/gallery.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/collections.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/fr/distribution.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      language: "it-IT",
      name: "Italiano",
      files: [
        {
          path: "/app/monocle-gallery/locales/it/pickerIntegration.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/bundleInspector.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/account.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/signin.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/checkout.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/navbar.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/welcome.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/gallery.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/collections.json",
          cache: undefined
        },
        {
          path: "/app/monocle-gallery/locales/it/distribution.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/app/monocle-gallery/locales/en/pickerIntegration.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/bundleInspector.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/account.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/signin.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/checkout.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/navbar.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/welcome.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/gallery.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/collections.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/en/distribution.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    language: "ja-JP",
    name: "日本語",
    files: [
      {
        path: "/app/monocle-gallery/locales/ja/pickerIntegration.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/bundleInspector.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/account.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/signin.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/checkout.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/navbar.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/welcome.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/gallery.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/collections.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/ja/distribution.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/app/monocle-gallery/locales/fr/pickerIntegration.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/bundleInspector.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/account.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/signin.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/checkout.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/navbar.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/welcome.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/gallery.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/collections.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/fr/distribution.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    files: [
      {
        path: "/app/monocle-gallery/locales/it/pickerIntegration.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/bundleInspector.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/account.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/signin.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/checkout.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/navbar.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/welcome.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/gallery.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/collections.json",
        cache: undefined
      },
      {
        path: "/app/monocle-gallery/locales/it/distribution.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/